import axios from '@/api/axios'
import { buildQuery } from '@/helpers/build-query.utils'

export default {
    getShipments: (params) => {
        const query = buildQuery(params)
        return axios.get(`/base/api/shipments?${query}`).then((r) => r.data)
    },
    getShipmentById: (id) => {
        return axios.get(`/base/api/shipments/${id}`).then((r) => r.data)
    },
    createShipment: (payload) => {
        return axios.post('/base/api/shipments', payload).then((r) => r.data)
    },
    getShipmentUsers: () => {
        return axios.get('/base/api/get-shipment-users').then((r) => r.data)
    },
    getShipmentUserWigs: (userId) => {
        return axios
            .get(`/base/api/get-shipment-user-wigs/${userId}`)
            .then((r) => r.data)
    },
    getShipmentUsersWithWigs: (senders) => {
        const query = buildQuery({ senders })
        return axios
            .get(`/base/api/get-shipment-users-with-wigs?${query}`)
            .then((r) => r.data)
    },
    getShipmentRecipients: (params) => {
        const query = buildQuery(params)
        return axios
            .get(`/base/api/get-shipment-recipients?${query}`)
            .then((r) => r.data)
    },
    updateWigBarcode: ({ wigId, form }) => {
        return axios({
            url: `/base/api/wig/${wigId}/updateWig`,
            method: 'post',
            data: form,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data',
            },
        }).then((r) => r.data)
    },
    closeShipmentItems: (id, payload) => {
        return axios
            .post(`/base/api/shipments/${id}/close`, payload)
            .then((r) => r.data)
    },
    getShipmentItems: (params) => {
        const query = buildQuery(params)
        return axios
            .get(`/base/api/shipment-items?${query}`)
            .then((r) => r.data)
    },
    bulkPaymentShipmentItems: (payload) => {
        return axios
            .post('/base/api/shipment-items/bulk-payment', payload)
            .then((r) => r.data)
    },
    getOpenShipmentReport: (params) => {
        const query = buildQuery(params)
        return axios
            .get(`/base/api/shipments/open-report?${query}`)
            .then((r) => r.data)
    },
    getUsersWithShipments: () => {
        return axios
            .get('/base/api/get-users-with-shipments')
            .then((r) => r.data)
    },
    returnShipmentItems: (id, payload) => {
        return axios
            .post(`/base/api/shipments/${id}/return`, payload)
            .then((r) => r.data)
    },
    bulkReturnShipmentItems: (payload) => {
        return axios
            .post('/base/api/shipment-items/bulk-return', payload)
            .then((r) => r.data)
    },
}
